// Rules for the logo an owner uploads for client quotes. Pure: no window, no database.
// Only PNG or JPEG, at most 300 KB. Never SVG (an SVG file can carry script). The logo is kept as a data URL
// on the owner's own business row (contractors.quote_logo) and printed as a data: image.

export const MAX_LOGO_BYTES = 300 * 1024;
export const LOGO_TYPES = ["image/png", "image/jpeg"];

export const LOGO_TOO_BIG = "That logo is too big. Use a PNG or JPEG under 300 KB.";
export const LOGO_WRONG_TYPE = "Use a PNG or JPEG file. Other kinds of image aren't accepted.";

// Checks the picked file before it is read. Returns "" when fine, otherwise a plain message.
export function logoFileProblem(file) {
  if (!file) return LOGO_WRONG_TYPE;
  if (!LOGO_TYPES.includes(file.type)) return LOGO_WRONG_TYPE;
  if (file.size > MAX_LOGO_BYTES) return LOGO_TOO_BIG;
  return "";
}

// A data URL is safe to print only if it is a base64 PNG or JPEG whose bytes really start like one,
// and is within the size limit. Anything else (SVG, other types, text with quotes) is refused.
// Also used on the way out of the database, so a bad stored value never reaches the page.
export function isSafeLogoDataUrl(url) {
  if (typeof url !== "string") return false;
  const m = /^data:(image\/png|image\/jpeg);base64,([A-Za-z0-9+/]+={0,2})$/.exec(url);
  if (!m) return false;
  const b64 = m[2];
  if (Math.floor((b64.length * 3) / 4) > MAX_LOGO_BYTES) return false;
  if (m[1] === "image/png") return b64.startsWith("iVBORw0KGgo");
  return b64.startsWith("/9j/");
}
